(() => {
  const OPEN_CLASS = "predictive-search--expanded";

  // Utilitaires
  const openPanel = (ps) => {
    if (!ps || ps.classList.contains(OPEN_CLASS)) return;
    ps.classList.add(OPEN_CLASS);
    const panel = ps.querySelector("#predictive-search-results");
    if (panel) {
      panel.hidden = false;
      panel.setAttribute("aria-expanded", "true");
    }
  };

  const closePanel = (ps) => {
    if (!ps || !ps.classList.contains(OPEN_CLASS)) return;
    ps.classList.remove(OPEN_CLASS);
    const panel = ps.querySelector("#predictive-search-results");
    if (panel) {
      panel.hidden = true;
      panel.setAttribute("aria-expanded", "false");
    }

    // 🚀 Vide le champ
    const input = ps.querySelector(".search-input");
    if (input) input.value = "";

    // 🚀 Supprime la classe color-scheme-1 quand on sort
    ps.classList.remove("color-scheme-1");
  };

  // Debounce léger pour l'input
  const debounce = (fn, delay = 120) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  // 1) Ouvrir/fermer en fonction du focus
  document.addEventListener("focusin", (e) => {
    const ps = e.target.closest("predictive-search-component");
    if (!ps) return;
    if (e.target.matches(".search-input")) openPanel(ps);
  });

  document.addEventListener("focusout", (e) => {
    const ps = e.target.closest("predictive-search-component");
    if (!ps) return;
    requestAnimationFrame(() => {
      if (!ps.contains(document.activeElement)) closePanel(ps);
    });
  });

  // 2) Fermer si clic / tap en dehors
  document.addEventListener(
    "pointerdown",
    (e) => {
      const psOpen = document.querySelectorAll(
        `predictive-search-component.${OPEN_CLASS}`
      );
      if (!psOpen.length) return;
      const target = e.target;
      psOpen.forEach((ps) => {
        if (!ps.contains(target)) closePanel(ps);
      });
    },
    { passive: true }
  );

  // 3) Taper dans l’input : ouvrir si non vide, fermer si vide
  const onType = debounce((input) => {
    const ps = input.closest("predictive-search-component");
    if (!ps) return;
    if (input.value.trim()) openPanel(ps);
    else closePanel(ps);
  });

  document.addEventListener(
    "input",
    (e) => {
      if (e.target.matches("predictive-search-component .search-input"))
        onType(e.target);
    },
    { passive: true }
  );

  // 4) ESC pour fermer
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const input = e.target.closest("predictive-search-component .search-input");
    if (!input) return;
    const ps = input.closest("predictive-search-component");
    closePanel(ps);
    input.blur();
  });
})();
